import * as Yup from "yup";

/***************************************************************
 * ログイン
 **************************************************************/
/**
 * エラーメッセージ
 */
export const ERR_MESSAGE = {
  usernameIsNull: "メールアドレスを入力してください。",
  passwordIsNull: "パスワードを入力してください",
  passwordConfirmIsNull: "パスワードを入力してください",
  mfaCodeIsNull: "認証コードを入力してください。",
};

/**
 * バリデーションルール
 */
export const LoginFormSchema = Yup.object({
  username: Yup.string().required(ERR_MESSAGE.usernameIsNull),
  password: Yup.string().required(ERR_MESSAGE.passwordIsNull),
});

/**
 * ログインAPI リクエスト
 */
export class LoginRequest {
  /** ユーザー名 */
  public username: string = "";
  /** パスワード */
  public password: string = "";
}

/**
 * ログインAPI レスポンス
 */
export class LoginResponse {
  /** ステータス */
  public status: string = "";
  /** コード */
  public code: string = "";
  /** 表示メッセージ */
  public displayMessage: string = "";
  /** エラーメッセージ */
  public errorMessages: string = "";
  /** ユーザーJSON情報 */
  public json: string = "";
  /** ログイン日時 */
  public lastLoginDate: string = "";
  /** トークン情報 */
  public token: string = "";
  /** 権限CD */
  public authList: any;
}

/***************************************************************
 * 二段階認証
 **************************************************************/
/**
 * バリデーションルール
 */
export const MfaFormSchema = Yup.object({
  mfaCode: Yup.string().required(ERR_MESSAGE.mfaCodeIsNull),
});

/**
 * ワンタイプパスコード認証API リクエスト
 */
export class MfaRequest {
  /** 認証コード */
  public mfaCode: string = "";
}

/**
 * ワンタイムパスコード認証API レスポンス
 */
export class MfaResponse {
  /** ステータス */
  public status: string = "";
  /** コード */
  public code: string = "";
  /** 表示メッセージ */
  public displayMessage: string = "";
  /** エラーメッセージ */
  public errorMessages: string = "";
}

/***************************************************************
 * パスワード変更要求API
 **************************************************************/
/**
 * バリデーションルール
 */
export const PasswordReminderFormSchema = Yup.object({
  username: Yup.string().required(ERR_MESSAGE.usernameIsNull),
});

/**
 * パスワード変更要求API リクエスト
 */
export class PasswordReminderRequest {
  /** メールアドレス */
  public username: string = "";
}

/**
 * パスワード変更要求API レスポンス
 */
export class PasswordReminderResponse {
  /** ステータス */
  public status: string = "";
  /** コード */
  public code: string = "";
  /** 表示メッセージ */
  public displayMessage: string = "";
  /** エラーメッセージ */
  public errorMessages: string = "";
}

/***************************************************************
 * パスワード変更URLチェックAPI
 **************************************************************/
/**
 * バリデーションルール
 */
export const PasswordUrlCheckFormSchema = Yup.object({
  userName: Yup.string().required(ERR_MESSAGE.usernameIsNull),
});

/**
 * パスワード変更URLチェックAPI リクエスト
 */
export class PasswordUrlCheckRequest {
  public expiry: string = "";
}

/**
 * パスワード変更URLチェックAPI レスポンス
 */
export class PasswordUrlCheckResponse {
  /** ステータス */
  public status: string = "";
  /** コード */
  public code: string = "";
  /** 表示メッセージ */
  public displayMessage: string = "";
  /** エラーメッセージ */
  public errorMessages: string = "";
}

/***************************************************************
 * パスワード変更API
 **************************************************************/
/**
 * バリデーションルール
 */
export const PasswordResetFormSchema = Yup.object({
  password: Yup.string().required(ERR_MESSAGE.passwordIsNull),
  passwordConfirm: Yup.string().required(ERR_MESSAGE.passwordConfirmIsNull),
});

/**
 * パスワード変更API リクエスト
 */
export class PasswordResetRequest {
  /** トークン */
  public expiry: string = "";
  /** パスワード */
  public password: string = "";
  /** パスワード確認 */
  public passwordConfirm: string = "";
}

/**
 * パスワード変更API レスポンス
 */
export class PasswordResetResponse {
  /** ステータス */
  public status: string = "";
  /** コード */
  public code: string = "";
  /** 表示メッセージ */
  public displayMessage: string = "";
  /** エラーメッセージ */
  public errorMessages: string = "";
}
